import { FormControl } from '@angular/forms';

import { CustomFormControl, customFormGroup } from '../utilities';

const currencyControl = (value?: string) => new FormControl(value ?? null);

export const moneyForm = () =>
  customFormGroup(
    {
      selectedCurrency: new CustomFormControl('', {
        multiKeyOptions: {
          keys: ['currency', 'cryptoCurrency'],
        },
      }),
      units: new FormControl(0),
      nanos: new FormControl(0),
    },
    {
      conditionalControls: [
        {
          conditions: [
            { key: 'currency', factory: currencyControl },
            { key: 'cryptoCurrency', factory: currencyControl },
          ],
          skipDefault: true,
        },
      ],
    } as const
  );

export type MoneyFormGroup = ReturnType<typeof moneyForm>;
